import { App } from 'vue';

import { Installable } from '@rygen/rygen-ui/config/Installable';
import { errorReporting } from '@rygen/rygen-ui/service/ErrorReportingService';

export class ErrorHandlingInstaller implements Installable {
  install(_app: App): void {
    errorReporting.start({ service: 'corsair-ui' });
  }
}

export const errorHandling = new ErrorHandlingInstaller();
